import { render } from "./HighFive.vue?vue&type=template&id=15c1056c&scoped=true"
import script from "./HighFive.vue?vue&type=script&lang=js"
export * from "./HighFive.vue?vue&type=script&lang=js"

import "./HighFive.vue?vue&type=style&index=0&id=15c1056c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c1056c"]])

export default __exports__